import { render, staticRenderFns } from "./OrgPicker.vue?vue&type=template&id=ba872284&scoped=true&"
import script from "./OrgPicker.vue?vue&type=script&lang=ts&"
export * from "./OrgPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba872284",
  null
  
)

export default component.exports